import {
  sceneBox,
  ScenePointer,
  TutorialScene,
} from '@affine/core/components/tutorial-scene';
import {
  clickRingTrack,
  pointerTrack,
  popTrack,
  pressTrack,
  type SceneStory,
} from '@affine/core/components/tutorial-scene/scene-story';
import * as scene from '@affine/core/components/tutorial-scene/tutorial-scene.css';
import clsx from 'clsx';

import * as styles from './choose-rows-scene.css';

const SIZE = { width: 520, height: 156 };
const LOOP = 6400;
const OUT = 5600;
const TABLE = { x: 40, y: 22, w: 280, h: 112 };
const RUN = { x: 356, y: 58, w: 128, h: 40 };
/** Row centres in stage coordinates; the pointer ticks the first two. */
const ROWS = [50, 78, 106];
const BOX_X = 64;
const CLICKS = [1100, 1900, 3000];

const story: SceneStory = {
  loopMs: LOOP,
  tracks: [
    pointerTrack(
      LOOP,
      [
        [0, 500, 210, 140],
        [1000, 1250, BOX_X, ROWS[0]!],
        [1800, 2050, BOX_X, ROWS[1]!],
        [2900, 3400, RUN.x + 64, RUN.y + 22],
        [4300, LOOP, 210, 140],
      ],
      SIZE
    ),
    pressTrack(LOOP, CLICKS),
    clickRingTrack(LOOP, CLICKS),
    popTrack('check-0', LOOP, CLICKS[0]! + 60, OUT),
    popTrack('check-1', LOOP, CLICKS[1]! + 60, OUT),
    popTrack('count-1', LOOP, CLICKS[0]! + 60, CLICKS[1]!),
    popTrack('count-2', LOOP, CLICKS[1]! + 60, OUT),
  ],
};

/**
 * How a manual run takes its rows: tick the rows in the table, and the Run
 * button counts them.
 */
export function ChooseRowsScene({ className }: { className?: string }) {
  return (
    <TutorialScene
      className={clsx(styles.stage, className)}
      height={SIZE.height}
      story={story}
      testId="choose-rows-scene"
      width={SIZE.width}
    >
      <div className={scene.canvas} />
      <div className={clsx(scene.box, styles.table)} style={sceneBox(TABLE)}>
        {ROWS.map((_, index) => (
          <span className={styles.row} key={index}>
            <span className={styles.checkbox}>
              {index < 2 ? (
                <span
                  className={styles.check}
                  data-scene-part={`check-${index}`}
                >
                  <svg className={styles.mark} viewBox="0 0 12 12">
                    <path d="M2.6 6.2 5 8.5l4.4-5" />
                  </svg>
                </span>
              ) : null}
            </span>
            <span
              className={scene.line}
              style={{ width: `${[78, 62, 70][index]}%` }}
            />
          </span>
        ))}
      </div>
      <div className={clsx(scene.box, styles.run)} style={sceneBox(RUN)}>
        <svg className={styles.play} viewBox="0 0 12 12">
          <path d="M3.5 2.5v7l6-3.5z" />
        </svg>
        <span className={styles.count}>
          (<span className={styles.digit}>0</span>
          <span className={styles.digitOver} data-scene-part="count-1">
            1
          </span>
          <span className={styles.digitOver} data-scene-part="count-2">
            2
          </span>
          )
        </span>
      </div>
      <ScenePointer size={SIZE} x={210} y={140} />
    </TutorialScene>
  );
}
